import { MainApi } from "./MainApi";
import { PageSearchCondition } from "../types/page";

export class PopupApi {
  static baseUrl = `${MainApi.urlPrefix}/user/catalog/pop-ups`;

  static getPopups = (condition: PageSearchCondition) => () =>
    MainApi.api.get(`${PopupApi.baseUrl}${MainApi.toParamStringFromObject(condition)}`);
}
